export function DatabaseIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.33337 5.83333V14.1667C3.33337 16.0076 6.31814 17.5 10 17.5C13.6819 17.5 16.6667 16.0076 16.6667 14.1667V5.83333M3.33337 5.83333C3.33337 7.67428 6.31814 9.16667 10 9.16667C13.6819 9.16667 16.6667 7.67428 16.6667 5.83333M3.33337 5.83333C3.33337 3.99238 6.31814 2.5 10 2.5C13.6819 2.5 16.6667 3.99238 16.6667 5.83333M16.6667 10C16.6667 11.8409 13.6819 13.3333 10 13.3333C6.31814 13.3333 3.33337 11.8409 3.33337 10'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  )
}
